// src/services/notificationService.js - RUTAS CORREGIDAS
import api from './api';
const RAW_API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const API_URL = RAW_API_URL.endsWith('/api')
  ? RAW_API_URL
  : `${RAW_API_URL.replace(/\/+$/, '')}/api`;

const notificationService = {
  async getInbox(params, signal) {
    const response = await api.get('/notifications/inbox', { params, signal, timeout: 15000 });
    return response.data;
  },
  async getNotifications(token) {
    const response = await fetch(`${API_URL}/notifications`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener notificaciones');
    }

    return await response.json();
  },

  // ✅ CORREGIDO: /unread-count en lugar de /unread/count
  async getUnreadCount(token) {
    const response = await fetch(`${API_URL}/notifications/unread-count`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener contador');
    }

    return await response.json();
  },

  async registerPushDevice(deviceToken, platform, token) {
    const response = await fetch(`${API_URL}/notifications/devices`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: deviceToken,
        platform,
        app_id: 'com.smtlink.gestion'
      })
    });

    if (!response.ok) throw new Error('No fue posible registrar el dispositivo para notificaciones push');
    return response.json();
  },

  async unregisterPushDevice(deviceToken, token) {
    const response = await fetch(`${API_URL}/notifications/devices`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: deviceToken })
    });

    if (!response.ok) throw new Error('No fue posible desactivar el dispositivo');
    return response.json();
  },

  async markAsRead(notificationId, token) {
    const response = await fetch(`${API_URL}/notifications/${notificationId}/read`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to mark notification as read');
    }

    return await response.json();
  },

  // ✅ CORREGIDO: /mark-all-read en lugar de /read-all
  async markAllAsRead(token) {
    const response = await fetch(`${API_URL}/notifications/mark-all-read`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to mark all notifications as read');
    }

    return await response.json();
  },

  async deleteNotification(notificationId, token) {
    const response = await fetch(`${API_URL}/notifications/${notificationId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Unable to delete notification');
    }

    return await response.json();
  },

  // ✅ CORREGIDO: /clear-all en lugar de /clear
  async clearAll(token) {
    const response = await fetch(`${API_URL}/notifications/clear-all`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al limpiar notificaciones');
    }

    return await response.json();
  },
};

export default notificationService;
